$(document).ready(function () {
    $(".item-state").on('change', function (e) {
        e.preventDefault()
        $(".item-country").empty();
        $(".item-municipality").empty();
        let state = $(".item-state option:selected").text()
        let data = new FormData()
        data.append('state', state);
        $.ajax({
            url: "/admin/get_cities",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                for (var i = 0; i < response.length; i++) {
                    let option = "<option value='" + response[i].ciudad + "'>" + response[i].ciudad + "</option>";
                    $(".item-country").append(option);
                }
                $(".item-country").prepend("<option value='' selected>Seleccione una opción</option>");
                $(".item-country").trigger("chosen:updated");
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value);
                });
            }
        })
    })

    $(".item-country").on('change', function (e) {
        e.preventDefault()
        $(".item-municipality").empty();
        let country = $(".item-country option:selected").text()
        let data = new FormData()
        data.append('country', country);
        $.ajax({
            url: "/admin/get_municipalities",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                for (var i = 0; i < response.length; i++) {
                    let option = "<option value='" + response[i].municipio + "'>" + response[i].municipio + "</option>";
                    $(".item-municipality").append(option);
                }
                $(".item-municipality").prepend("<option value='' selected>Seleccione una opción</option>");
                $(".item-municipality").trigger("chosen:updated");
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value);
                });
            }
        })
    })

    $(".item-municipality").on('change', function (e) {
        e.preventDefault()
        let municipality = $(".item-municipality option:selected").text()
        let data = new FormData()
        data.append('municipality', municipality);
        $.ajax({
            url: "/admin/get_colonies",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                console.log(response)
                for (var i = 0; i < response.length; i++) {
                    let option = "<option value='" + response[i].id + "'>" + response[i].asentamiento + "</option>";
                    $(".item-cologne").append(option);
                }
                $(".item-cologne").prepend("<option value='' selected>Seleccione una opción</option>");
                $(".item-cologne").trigger("chosen:updated");
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value);
                });
            }
        })
    })

    $("#form-detail-shipping-cost").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $(".loader_").addClass("loading")
        $.ajax({
            url: "/admin/save-zip-codes",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.type == "success") {
                        alertSuccess(data.msg)
                        clearSelects()
                        document.getElementById('table-detail-shipping-cost').innerHTML = response.view;
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)
            },
            error: function (errors, xhr, status,) {
                console.log(errors)
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value);
                });*/
            }
        })
    })

    $("#detail-zip-codes").DataTable({
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
    })

    let list_zip_codes = $("#detail-zip-codes").DataTable()


    window.deleteDetailShippingCost = function (id,shipping_cost_id){
        let $tr = $(this).closest('tr');
        let data = new FormData
        data.append('id',id)
        data.append('shipping_cost_id',shipping_cost_id)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $(".loader_").addClass("loading")
                sendInfoDelete(data,'/admin/delete-item-shipping-cost-detail',$tr)
            }
        })
    }


    function sendInfoDelete(data,route,$tr) {
        $.ajax({
            method: "POST",
            url: route,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: data,
            success: function (response) {
                setTimeout(function () {
                    if (response.type == "success") {
                        $(".loader_").removeClass("loading")
                        alertSuccess(response.msg)
                        document.getElementById('table-detail-shipping-cost').innerHTML = response.view;
                    } else {
                        $(".loader_").removeClass("loading")
                        alertError(response.msg)
                    }
                }, 1000)
            }
        })
    }

    function clearSelects() {

        $(".item-municipality").empty();
        $(".item-cologne").empty();
        $(".item-country").empty();

        //$(".item-state").prepend("<option value='' selected>Seleccione una opción</option>");
        $(".item-municipality").prepend("<option value='' selected>Seleccione una opción</option>");
        $(".item-cologne").prepend("<option value='' selected>Seleccione una opción</option>");
        $(".item-country").prepend("<option value='' selected>Seleccione una opción</option>");

        //$(".item-state").trigger("chosen:updated");
        $('#item-state').val('').trigger('chosen:updated');
        $(".item-cologne").trigger("chosen:updated");
        $(".item-country").trigger("chosen:updated");
        $(".item-municipality").trigger("chosen:updated");
    }
})
